module.exports = __webpack_public_path__ + "media/applications/assets/images/materials/sweatshirt/1-e8ed66644a3792a79c7d593be1f9cfb3.jpg";